import { createContext, useContext } from "react";

export const LangContext = createContext("en");
export const useLang = () => useContext(LangContext);
export const useT = () => STRINGS[useContext(LangContext)];

export const STRINGS = {
  en: {
    nav_manifesto: "Heritage",
    nav_menu: "Menu",
    nav_gallery: "Gallery",
    nav_reviews: "Reviews",
    nav_contact: "Visit Us",
    nav_reserve: "Reserve a Table",
    hero_eyebrow: "Salon de Thé · Rue d'Enfer, Genève",
    hero_line_1: "A sanctuary of",
    hero_line_2: "food, flavor",
    hero_line_3: "& tea.",
    hero_subtitle: "Persian Restaurant & Artisanal Pâtisserie in the heart of Geneva",
    hero_rating: "4.5 · 288 reviews",
    hero_price: "CHF 10–60",
    hero_cta_menu: "Explore the Menu",
    hero_cta_book: "Reserve A Table",
    hero_cta_reserve: "Reserve a Table",
    hero_hours: "Mon–Sat 10:00–19:00 · Sun closed",
    marquee_items: ["Persian Hospitality in Geneva", "Handcrafted Pistachio Cake", "Saffron-Infused Delights", "Rue d'Enfer · 1204 Genève", "Teas from the Silk Road", "Since 2012"],
    ch1_label: "Chapter 01 — Heritage",
    ch1_title: "Persian ritual, Geneva grace.",
    ch1_body_1: "Tucked along Rue d'Enfer, La Bergamote is a quiet salon where the Persian tea ceremony meets Swiss precision. Every pot is brewed to the minute; every pastry leaves the kitchen the same morning it is served.",
    ch1_body_2: "Our pistachios arrive from Kerman, our saffron from Khorasan — folded into cakes, rice and tea the way our families have done for generations.",
    ch1_tile_1_t: "Kerman Pistachio",
    ch1_tile_1_d: "Stone-ground each week for our signature cake.",
    ch1_tile_2_t: "Saffron of Khorasan",
    ch1_tile_2_d: "Hand-picked threads, bloomed in rose water.",
    ch1_tile_3_t: "The Tea Ritual",
    ch1_tile_3_d: "Samovar-brewed, served in estekan glasses.",
    ch2_label: "Chapter 02 — The Menu",
    ch2_title: "What we pour & plate",
    ch2_sub: "Sweets, teas and saffron dishes, made in-house every day.",
    menu_tab_sweets: "Sweets & Pâtisserie",
    menu_tab_tea: "Teas & Coffees",
    menu_tab_savouries: "Saffron & Savoury",
    menu_badge_signature: "Signature",
    menu_badge_popular: "Popular",
    menu_explore: "Explore The Menu",
    menu_note: "Opens our menu booklet (PDF) · CHF 10–60 per person",
    ch3_label: "Chapter 02 — Gallery",
    ch3_title: "Inside the salon",
    ch3_sub: "A glimpse of the place, the counter and what comes out of the kitchen.",
    ch3_notice: "More photographs from the salon are on their way.",
    ch4_label: "Chapter 03 — Reviews",
    ch4_title: "Word of mouth",
    reviews_all_google: "Read all 288 reviews on Google",
    ch4_score_label: "based on 288 Google reviews",
    ch4_keywords: ["persian food · 24", "welcoming atmosphere · 13", "saffron · 8", "pistachio cake · 7"],
    ch5_label: "Chapter 04 — Visit",
    ch5_title: "Find Us In The Heart Of Geneva",
    contact_address: "Rue d'Enfer, 1204 Genève",
    contact_phone: "022 312 23 33",
    contact_website: "labergamote.ch",
    contact_directions: "Get Directions",
    contact_hours_title: "Opening hours",
    day_mon: "Monday", day_tue: "Tuesday", day_wed: "Wednesday", day_thu: "Thursday", day_fri: "Friday", day_sat: "Saturday", day_sun: "Sunday",
    hours_open: "10:00 – 19:00",
    hours_closed: "Closed",
    enquiry_title: "Send an enquiry or table request",
    enquiry_sub: "We reply within a day — for same-day tables, call us.",
    field_name: "Name",
    field_email: "Email",
    field_phone: "Phone (optional)",
    field_date: "Preferred date",
    field_guests: "Guests",
    field_message: "Your message",
    field_message_ph: "A birthday cake, a table for four, a question about our teas…",
    enquiry_submit: "Send Request",
    enquiry_sending: "Sending…",
    toast_success: "Merci! Your enquiry has been sent to La Bergamote.",
    toast_error: "Something went wrong — please call us at 022 312 23 33.",
    footer_tagline: "Salon de thé persan · Pâtisserie artisanale",
    footer_instagram: "Follow us on Instagram",
    sh_title: "The Shop",
    sh_private: "Private preview — only people with this link can see this page.",
    sh_empty: "Your cart is empty.",
    sh_add: "Add to cart",
    sh_added: "Added to cart",
    sh_cart: "Cart",
    sh_subtotal: "Subtotal",
    sh_checkout: "Checkout",
    sh_remove: "Remove",
    sh_size: "Size",
    sh_cancelled: "Payment cancelled — your cart is still here.",
    sh_email: "Email",
    sh_first: "First name",
    sh_last: "Last name",
    sh_address: "Street address",
    sh_postal: "Postal code",
    sh_city: "City",
    sh_country: "Country",
    sh_pay: "Pay by card",
    sh_pay_note: "Test mode — no real money moves. Card 4242 4242 4242 4242.",
    sh_success_title: "Merci! Order received.",
    sh_success_sub: "Your payment went through (test mode). We will prepare your order and ship it to you.",
    sh_back_shop: "Back to the shop",
    sh_checking: "Confirming your payment…",
    sh_owner: "Owner — add an item",
    sh_name_fr: "Name (French)",
    sh_name_en: "Name (English)",
    sh_desc: "Description (French)",
    sh_sizes: "Sizes & prices — one per line, e.g. «250 g 14»",
    sh_image: "Photo link (URL)",
    sh_add_product: "Add item",
    sh_product_added: "Item added to the shop",
    sh_delete: "Delete",
    sh_shipping_note: "We deliver within Geneva only.",
    sh_city_fixed: "Geneva",
    sh_specialties: "Sweets & Specialties",
    sh_tea: "Tea Selection",
    sh_tea_empty: "Teas are on their way — check back soon.",
    sh_category: "Section",
    sh_cat_specialties: "Sweets & Specialties",
    sh_cat_tea: "Tea Selection",
    footer_rights: "La Bergamote Genève. All rights reserved.",
  },
  fr: {
    nav_manifesto: "Héritage",
    nav_menu: "La Carte",
    nav_gallery: "Galerie",
    nav_reviews: "Avis",
    nav_contact: "Nous Trouver",
    nav_reserve: "Réserver une Table",
    hero_eyebrow: "Salon de Thé · Rue d'Enfer, Genève",
    hero_line_1: "Un sanctuaire de",
    hero_line_2: "cuisines, saveurs",
    hero_line_3: "& de thés.",
    hero_subtitle: "Restaurant persan & pâtisserie artisanale au cœur de Genève",
    hero_rating: "4.5 · 288 avis",
    hero_price: "CHF 10–60",
    hero_cta_menu: "Voir le Menu",
    hero_cta_book: "Réserver une Table",
    hero_cta_reserve: "Réserver une Table",
    hero_hours: "Lun–Sam 10h00–19h00 · Dim fermé",
    marquee_items: ["L'hospitalité perse à Genève", "Gâteau à la pistache maison", "Douceurs infusées au safran", "Rue d'Enfer · 1204 Genève", "Thés de la Route de la Soie", "Depuis 2012"],
    ch1_label: "Chapitre 01 — Héritage",
    ch1_title: "Rituel perse, grâce genevoise.",
    ch1_body_1: "Niché le long de la Rue d'Enfer, La Bergamote est un salon paisible où la cérémonie du thé persan rencontre la précision suisse. Chaque théière est infusée à la minute près ; chaque pâtisserie sort de la cuisine le matin même.",
    ch1_body_2: "Nos pistaches arrivent de Kerman, notre safran du Khorasan — mariés aux gâteaux, aux riz et aux thés comme nos familles le font depuis des générations.",
    ch1_tile_1_t: "Pistache de Kerman",
    ch1_tile_1_d: "Moulue à la pierre chaque semaine pour notre gâteau signature.",
    ch1_tile_2_t: "Safran du Khorasan",
    ch1_tile_2_d: "Fils cueillis à la main, infusés à l'eau de rose.",
    ch1_tile_3_t: "Le Rituel du Thé",
    ch1_tile_3_d: "Infusé au samovar, servi dans des verres estekan.",
    ch2_label: "Chapitre 02 — La Carte",
    ch2_title: "Ce que l'on sert",
    ch2_sub: "Douceurs, thés et plats au safran, faits maison chaque jour.",
    menu_tab_sweets: "Douceurs & Pâtisseries",
    menu_tab_tea: "Thés & Cafés",
    menu_tab_savouries: "Safran & Salé",
    menu_badge_signature: "Signature",
    menu_badge_popular: "Populaire",
    menu_explore: "Découvrir la Carte",
    menu_note: "Ouvre notre livret de menu (PDF) · CHF 10–60 par personne",
    ch3_label: "Chapitre 02 — Galerie",
    ch3_title: "Dans le salon",
    ch3_sub: "Un aperçu du restaurant, du comptoir et de ce qui sort de la cuisine.",
    ch3_notice: "D'autres photographies du salon arrivent bientôt.",
    ch4_label: "Chapitre 03 — Avis",
    ch4_title: "Le bouche à oreille",
    reviews_all_google: "Lire les 288 avis sur Google",
    ch4_score_label: "d'après 288 avis Google",
    ch4_keywords: ["cuisine perse · 24", "accueil chaleureux · 13", "safran · 8", "gâteau pistache · 7"],
    ch5_label: "Chapitre 04 — Visite",
    ch5_title: "Retrouvez-nous au cœur de Genève",
    contact_address: "Rue d'Enfer, 1204 Genève",
    contact_phone: "022 312 23 33",
    contact_website: "labergamote.ch",
    contact_directions: "Itinéraire",
    contact_hours_title: "Horaires d'ouverture",
    day_mon: "Lundi", day_tue: "Mardi", day_wed: "Mercredi", day_thu: "Jeudi", day_fri: "Vendredi", day_sat: "Samedi", day_sun: "Dimanche",
    hours_open: "10h00 – 19h00",
    hours_closed: "Fermé",
    enquiry_title: "Envoyer une demande ou réserver",
    enquiry_sub: "Nous répondons sous 24h — pour une table le jour même, appelez-nous.",
    field_name: "Nom",
    field_email: "E-mail",
    field_phone: "Téléphone (optionnel)",
    field_date: "Date souhaitée",
    field_guests: "Convives",
    field_message: "Votre message",
    field_message_ph: "Un gâteau d'anniversaire, une table pour quatre, une question sur nos thés…",
    enquiry_submit: "Envoyer la demande",
    enquiry_sending: "Envoi…",
    toast_success: "Merci ! Votre demande a bien été envoyée à La Bergamote.",
    toast_error: "Une erreur est survenue — appelez-nous au 022 312 23 33.",
    footer_tagline: "Salon de thé persan · Pâtisserie artisanale",
    footer_instagram: "Suivez-nous sur Instagram",
    sh_title: "La Boutique",
    sh_private: "Aperçu privé — seules les personnes avec ce lien voient cette page.",
    sh_empty: "Votre panier est vide.",
    sh_add: "Ajouter au panier",
    sh_added: "Ajouté au panier",
    sh_cart: "Panier",
    sh_subtotal: "Sous-total",
    sh_checkout: "Commander",
    sh_remove: "Retirer",
    sh_size: "Format",
    sh_cancelled: "Paiement annulé — votre panier est toujours là.",
    sh_email: "E-mail",
    sh_first: "Prénom",
    sh_last: "Nom",
    sh_address: "Adresse",
    sh_postal: "NPA",
    sh_city: "Ville",
    sh_country: "Pays",
    sh_pay: "Payer par carte",
    sh_pay_note: "Mode test — aucun argent réel. Carte 4242 4242 4242 4242.",
    sh_success_title: "Merci ! Commande reçue.",
    sh_success_sub: "Votre paiement est passé (mode test). Nous préparons votre commande et vous l'expédions.",
    sh_back_shop: "Retour à la boutique",
    sh_checking: "Confirmation du paiement…",
    sh_owner: "Propriétaire — ajouter un article",
    sh_name_fr: "Nom (français)",
    sh_name_en: "Nom (anglais)",
    sh_desc: "Description (français)",
    sh_sizes: "Formats & prix — un par ligne, ex. «250 g 14»",
    sh_image: "Lien de la photo (URL)",
    sh_add_product: "Ajouter l'article",
    sh_product_added: "Article ajouté à la boutique",
    sh_delete: "Supprimer",
    sh_shipping_note: "Livraison sur Genève uniquement.",
    sh_city_fixed: "Genève",
    sh_specialties: "Douceurs & Spécialités",
    sh_tea: "Sélection de Thés",
    sh_tea_empty: "Les thés arrivent bientôt — revenez vite.",
    sh_category: "Section",
    sh_cat_specialties: "Douceurs & Spécialités",
    sh_cat_tea: "Sélection de Thés",
  },
};
